import axios from 'axios';

const token = localStorage.getItem('user-token');
const api_url = process.env.VUE_APP_API_VIDA_URL;

export default {
  async getBanksWithSearch(search) {
    try {
      const response = await axios.get(
        `${api_url}/banks?search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
